import React, { useState, useEffect,useRef } from 'react';
import Cookies from "universal-cookie";
import middleware from '../../Api/Middleware';
import PrinterIcon from "../Icons/printer.png";
import placeholder from '../Icons/empty-placeholder.jpg';
import packageIcon from '../Icons/package.png';
import clipboardWithCheckIcon from '../Icons/order-verified.png';
import homeIcon from '../Icons/home.png';
import { ButtonBlue, ButtonLightGrey } from '../../HouseStyle/Components/Buttons';
import * as Icons from "../../HouseStyle/Icons";
import { pdf } from '@react-pdf/renderer';
import ShippingLabelPDF from '../GenerateLabelPDF';
import { PencilIcon } from 'lucide-react';
import {faPencilAlt, faX,faCheck } from '@fortawesome/free-solid-svg-icons';
import EditShipmentModal from './EditShipmentModal';
import { Link } from 'react-router-dom';
import { formatCurrency, parseCurrency } from '../../../utils';
import { BorderedDropDown } from '../../HouseStyle/Components/DropDowns';
import ToastError from "../../Toasts/ToastError";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const VerzendComponent = ({setOrder, order, shipmentMethod, customer, deliveryAddress, productsToProcess = [], fetchAll }) => {
  const [shipments, setShipments] = useState([]);
  const [shipmentProducts, setShipmentProducts] = useState([]);
  const [providers, setProviders] = useState([]);
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showEditShipmentModal, setShowEditShipmentModal] = useState(false);
  const [selectedPackageToEdit, setSelectedPackageToEdit] = useState(null);
  const [editStatus,setEditStatus] = useState(null);
  // const [] = useState();
  const [barcodeURL, setBarcodeURL] = useState();
  const [companyAddress, setCompanyAddress] = useState();
  const anonymiseCustomer = customer.internal_id === 'C-10000';
  const isShippingOrder = order.shipment_method === 1;
  const [formData, setFormData] = useState({});
  const prevFormData=useRef(formData);
  const updateState=useRef(false);
  
  // const [customer, setCustomer] = useState();
  // const [barcode, setBarcode] = useState("");
  // const [barcodeURL, setBarcodeURL] = useState("");

  const strip = (html) => {
    let doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  }

  useEffect(() => {
    const fetchShipmentsAndProducts = async () => {
      try {
        setLoading(true);
        setError(null);
        const customerType = customer.internal_id.charAt(0) === "C" ? 'consumers' : 'businesses';

        const companyAddressResponse = await middleware.get('settings/backoffice');
        setCompanyAddress(companyAddressResponse.data.data[0]);

        const response = await middleware.get(`myparcel/shipments?order_id=${order.order_id}`);
        const shipmentData = response.data.data || [];
          
        // const customerResponse = await middleware.get(`${customerType}?internal_id=${internal_id}`);

        const sortedShipments = shipmentData.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        setShipments(sortedShipments);

        // setCustomer(customerResponse.data.data[0] || {});
        
        let pkgs = [];
        sortedShipments.forEach(shipment => {
          shipment.shipment_packages.map((pkg) => {
            pkgs.push(pkg);
          });
        });
        setPackages(pkgs);

        const ships = sortedShipments.map(
          shipment => [...shipment.shipment_sold_products]
        );

        setShipmentProducts(ships);

      } catch (error) {
        console.error('Error fetching shipments or products:', error);
        setError('Er is een fout opgetreden bij het ophalen van de verzendingen of producten');
      } finally {
        setLoading(false);
      }
    };
    fetchShipmentsAndProducts();
  }, [order.order_id]);

  const showLabel = async (pkg) => {
    const pdfBlob = await pdf(<ShippingLabelPDF
      barcodeURL={barcodeURL}
      companyAddress={companyAddress}
      deliveryAddress={deliveryAddress}
      customer={customer}
    />).toBlob();

    const url = URL.createObjectURL(pdfBlob);
    window.open(url, '_blank');

    setTimeout(() => URL.revokeObjectURL(url), 100);
  }

  const handlePrintLabel = async (pkg) => {
    try {
      const cookies = new Cookies();
      const baseURL = middleware.defaults.baseURL;
      const response = await fetch(baseURL + 'shipments/labels/' + pkg.package_number + ".pdf", {
        method: 'GET',
        headers: {
          ApiKey: cookies.get('token', { secure: false })
        }
      });
      
      if (!response.ok) throw new Error('Failed to fetch PDF');
      const pdfBlob = await response.blob();

      const url = URL.createObjectURL(pdfBlob);
      window.open(url, '_blank');
      // const link = document.createElement('a');
      // link.href = url;
      // link.download = pkg.package_number + ".pdf";
      // link.click();
      // URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
    }
    // fetch(pkg.package_label_url, {
    //   headers: {
    //     'ApiKey': "bruh"
    //   }
    // });

    // window.location.href = pkg.package_label_url;
  }

  useEffect(() => {
    const fetchProviders = async () => {
      try {
        const providersResponse = await middleware.get(`shipments/providers`);
        const providers = providersResponse.data;
        setProviders(providers);
      } catch (error) {
        console.error('Error fetching providers:', error);
      }
    };
    fetchProviders();
  }, [shipments]);

  const getProviderAndMethod = (shipment, pkg, providers) => {
    if (!shipment || !pkg || !providers) return '';

    try {
      const found_provider = providers.find(p => p.provider_id === shipment.shipment_provider_id);
      const found_method = found_provider?.methods?.find((m) => m.provider_method_id == shipment.shipment_method_id);
      
      return `${found_provider.provider_name} - ${found_method?.name ?? 'Niet bekend'}`;
    } catch (err) {
      console.error(err);
    }
    return '';
  };

  const PackageStatus = ({ pickup, status }) => {
    const steps = [
      {
        label: "Aangemaakt",
        completedIcon: packageIcon,
        incompleteIcon: packageIcon,
      },
      {
        label: "Verzonden",
        completedIcon: Icons.Verify,
        incompleteIcon: clipboardWithCheckIcon,
      },
      {
        label: "Afgeleverd",
        completedIcon: Icons.Home,
        incompleteIcon: homeIcon,
      },
    ];

    const pickupSteps = [
      {
        label: "Aangemaakt",
        completedIcon: packageIcon,
        incompleteIcon: packageIcon,
      },
      {
        label: "Ligt klaar in de winkel",
        completedIcon: Icons.Verify,
        incompleteIcon: clipboardWithCheckIcon,
      },
      {
        label: "Opgehaald",
        completedIcon: Icons.Home,
        incompleteIcon: homeIcon,
      },
    ];

    let isCancelled = false;
    if (status === 3) {
      isCancelled = true;
    }
    
    return (
      <div className={isCancelled ? "cancelled-status-container package-status-container w-100" : "package-status-container w-100"}>
        {pickup ? (
          pickupSteps.map((step, i) => {
            // Bestelling in verwerking of afgeleverd
            const isCompleted = status >= i;
            return (
              <div className={isCancelled ? 'cancelled-status packaging-status' : 'packaging-status'} key={i}>
                <div className={isCancelled ? "cancelled-status-icon package-status-icon" : "package-status-icon"} id={isCompleted ? "completed" : undefined}>
                  <img src={isCompleted ? step.completedIcon : step.incompleteIcon} alt={step.label} />
                </div>
                <span className={isCancelled ? 'cancelled-label' : ''}>{step.label}</span>
              </div>
            );
          })
        ) : (
          steps.map((step, i) => {
            // Bestelling in verwerking of afgeleverd
            const isCompleted = status >= i;
            return (
              <div className={isCancelled ? 'cancelled-status packaging-status' : 'packaging-status'} key={i}>
                <div className={isCancelled ? "cancelled-status-icon package-status-icon" : "package-status-icon"} id={isCompleted ? "completed" : undefined}>
                  <img src={isCompleted ? step.completedIcon : step.incompleteIcon} alt={step.label} />
                </div>
                <span className={isCancelled ? 'cancelled-label' : ''}>{step.label}</span>
              </div>
            );
          })
        )}
      </div>
    );
  };

  const submitForm = async (data) => {
    if (!updateState.current&&prevFormData.current!==formData) {
      try {
      prevFormData.current = formData;
        updateState.current = true;
        await middleware.put(`myparcel/shipments/${data.shipment_id}`, {
          shipment_packages: [
            {
              shipment_package_id: data.shipment_package_id,
              ...formData[data.shipment_id],
            },
          ],
        });
        const res= await 
        middleware.get(`orders/fullorder?order_number=${order.order_number}`);
        setOrder(res.data.data);
      } catch (err) {
        console.error(err);
        ToastError(
          `Er ging iets mis bij het opslaan van uw wijzigingen. Probeer het later nog eens of neem contact op als het probleem blijft bestaan.`
        );
        return;
      } finally {
        updateState.current = false;
      }

      setPackages((prev) =>
        prev.map(
          (pkg) =>
            pkg.shipment_package_id === data.shipment_package_id
              ? { ...pkg, ...formData[data.shipment_id] } // Update the edited package with new form data
              : pkg // Keep other packages unchanged
        )
      );
    }

  };
  const updateFormData = (field, value,shipment_id) => {
      prevFormData.current = formData;
      setFormData((prev) => {
        return {
          ...prev,
          [shipment_id]: {
            [field]: value,
          },
        };
      });
  }
  const shopstatuses = [
    { title: "Aangemaakt", value: 0 },
    { title: "Ligt klaar in de winkel", value: 1 },
    { title: "Opgehaald", value: 2 },
    { title: "Geanuleerd", value: 3 },
  ];

  const pickstatuses=
     [
      {
        title: "Aangemaakt",
        value:0,
      },
      {
        title: "Verzonden",
        value:1,
      },
      {
        title: "Afgeleverd",
        value:2,
      },
    ];

  return (
    <> 
            
      {loading ?
      (
        <div className="whiteBox mb-4 p-4 align-center" style={{height: '473px'}}>
          <span className='BlockTitle' style={{color: '#00000069', height: '1000px', marginLeft: '24px'}}>Loading...</span>
        </div>
      ) : 
      shipments.map((shipment, index) => {
        let productsForShipment = {};
        const internalShipping = shipment.shipment_provider_id === 1;

        try {
          productsForShipment = shipmentProducts[index] || {};
        } catch (error) {
          console.error(error);
        }

        return (
          <div className="whiteBox p-5 pb-3 mb-4 align-center" key={index}>
            <div className="d-flex justify-content-between align-items-center pb-2 creditering-header">
              {isShippingOrder ? (
                <>
                  <div className="d-flex flex-row gap-3 mb-0 justify-content-between w-100 me-3">
                    <h5 className="fw-bold BlockTitle">
                      Verzending: {shipment.shipment_number}
                    </h5>
                    {/* Only show edit icon if ALL packages use internal shipping (provider_id 1) and if the shipment is not cancelled or delivered - external providers cannot be modified */}
                    {internalShipping &&
                      [1, 2, 3, 4].includes(shipment.shipment_status) && (
                        <>
                        {editStatus === shipment.shipment_id ? (
                          <div className="d-flex gap-3 align-items-end">
                            <div className="d-flex align-items-baseline gap-3 border-end pe-3">
                              <div className="flex-grow ">
                                <BorderedDropDown
                                  size="m"
                                  selectedValue={
                                    formData[
                                      shipment.shipment_packages[0].shipment_id
                                    ]?.status ??
                                    shipment.shipment_packages[0].status
                                  }
                                  setSelectedValue={(value) => {
                                    updateFormData(
                                      "status",
                                      value,
                                      shipment.shipment_packages[0].shipment_id
                                    );
                                  }}
                                  placeholder="Aangemaakt"
                                  options={pickstatuses}
                                />
                              </div>
                              <FontAwesomeIcon icon={faX} onClick={()=>setEditStatus(null)} />
                              <FontAwesomeIcon
                                icon={faCheck}
                                onClick={() => {
                                  submitForm(shipment.shipment_packages[0]);
                                  setEditStatus(null);
                                }}
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="d-flex gap-3 align-items-center border-end pe-3">
                            <div>
                              {
                                pickstatuses.find(
                                  (e) =>
                                    e.value ===
                                    (formData[
                                      shipment.shipment_packages[0].shipment_id
                                    ]?.status ??
                                      shipment.shipment_packages[0].status)
                                ).title
                              }
                            </div>
                            <FontAwesomeIcon
                              onClick={() => {
                                setEditStatus(shipment.shipment_id);
                                setSelectedPackageToEdit(
                                  shipment.shipment_packages[0]
                                );
                              }}
                              width="1rem"
                              height="1rem"
                              style={{ cursor: "pointer" }}
                              icon={faPencilAlt}
                            />
                          </div>
                        )}
                </>
                      )}
                  </div>
                  {!anonymiseCustomer ? (
                    shipment.shipment_packages[0].package_label_url ? (
                      <ButtonLightGrey
                        onClickFunction={() =>
                          handlePrintLabel(shipment.shipment_packages[0])
                        }
                        text={"Print verzendlabel"}
                        icon={PrinterIcon}
                      />
                    ) : (
                      <ButtonLightGrey
                        onClickFunction={() =>
                          showLabel(shipment.shipment_packages[0])
                        }
                        text={"Print verzendlabel"}
                        icon={PrinterIcon}
                      />
                    )
                  ) : (
                    ""
                  )}
                </>
              ) : (
                <>
                  <div className="d-flex flex-row gap-3 mb-0">
                    <h5 className="fw-bold BlockTitle">
                      Ophalen: {shipment.shipment_number}
                    </h5>
                  </div>
                  {/* Only show edit icon if ALL packages use internal shipping (provider_id 1) and if the shipment is not cancelled or delivered - external providers cannot be modified */}
                  {internalShipping &&
                    packages.find((e) => e.shipment_id === shipment.shipment_id)
                      .status !== 3 && (
                      <>
                        {editStatus === shipment.shipment_id ? (
                          <div className="d-flex gap-3 align-items-end">
                            <div className="d-flex align-items-baseline gap-3">
                              <div className="flex-grow ">
                                <BorderedDropDown
                                  size="m"
                                  selectedValue={
                                    formData[
                                      shipment.shipment_packages[0].shipment_id
                                    ]?.status ??
                                    shipment.shipment_packages[0].status
                                  }
                                  setSelectedValue={(value) => {
                                    updateFormData(
                                      "status",
                                      value,
                                      shipment.shipment_packages[0].shipment_id
                                    );
                                  }}
                                  placeholder="Aangemaakt"
                                  options={shopstatuses}
                                />
                              </div>
                              <FontAwesomeIcon icon={faX} onClick={()=>setEditStatus(null)} />
                              <FontAwesomeIcon
                                icon={faCheck}
                                onClick={() => {
                                  submitForm(shipment.shipment_packages[0]);
                                  setEditStatus(null);
                                }}
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="d-flex gap-3 align-items-center">
                            <div>
                              {
                                shopstatuses.find(
                                  (e) =>
                                    e.value ===
                                    (formData[
                                      shipment.shipment_packages[0].shipment_id
                                    ]?.status ??
                                      shipment.shipment_packages[0].status)
                                ).title
                              }
                            </div>
                            <FontAwesomeIcon
                              onClick={() => {
                                setEditStatus(shipment.shipment_id);
                                setSelectedPackageToEdit(
                                  shipment.shipment_packages[0]
                                );
                              }}
                              width="1rem"
                              height="1rem"
                              style={{ cursor: "pointer" }}
                              icon={faPencilAlt}
                            />
                          </div>
                        )}
                      </>
                    )}
                </>
              )}
            </div>

            {Array.isArray(productsForShipment) &&
            productsForShipment.length > 0 ? (
              <ul className="list-group list-group-flush mb-5">
                {productsForShipment.map((item, idx) => {
                  const product = productsToProcess.find(
                    (p) => p.sold_product_id === item.order_sold_product_id
                  );

                  const price = product?.price_incl_tax;
                  return (
                    <li
                      key={idx}
                      className="verwerk-list-group-item bottom-border-line d-flex justify-content-between align-items-center gap-3 pb-2 pt-2"
                    >
                      <div className="d-flex flex-row gap-3 flex-grow-1">
                        <div className="d-flex align-items-center">
                          {/* Product image */}
                          <img
                            src={
                              product?.image?.path
                                ? middleware.defaults.imagesBaseURL +
                                  product.image?.path
                                : placeholder
                            }
                            className="rounded-circle p-2 me-3 object-fit-cover"
                            height={100}
                            width={100}
                            alt="placeholder..."
                          />

                          {/* Product info */}
                          <div className="d-flex flex-column justify-content-center align-items-start">
                            <Link
                              className="new-link-color"
                              to={`/producten/bewerken/${product?.product_id}`}
                              target="_blank"
                            >
                              {product?.product_name}
                            </Link>
                            {product?.product_description && (
                              <p className="text-muted small mb-0">
                                {strip(product?.product_description)?.length <
                                100
                                  ? strip(product?.product_description)
                                  : strip(product?.product_description)?.slice(
                                      0,
                                      100
                                    ) + "..."}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Product price info */}
                      <div className="d-flex align-items-center justify-content-end gap-3 gap-xxl-5 flex-grow-1">
                        {product?.sale_amount > 0 ? (
                          <div className="d-flex flex-column">
                            <span className="text-nowrap text-muted text-decoration-line-through text-secondary">
                              {formatCurrency(price)}
                            </span>
                            <span>
                              {formatCurrency(
                                product?.sale_unit === 0
                                  ? price - product?.sale_amount
                                  : (price * (100 - product?.sale_amount)) / 100
                              )}
                            </span>
                          </div>
                        ) : (
                          <span className="text-nowrap">
                            {formatCurrency(price)}
                          </span>
                        )}
                        <span className="text-nowrap">x{item.amount}</span>
                        <span className="fw-semibold">
                          {formatCurrency(
                            (product?.sale_unit === 0
                              ? price - product?.sale_amount
                              : parseCurrency(
                                  (price * (100 - product?.sale_amount)) / 100
                                )) * item.amount
                          )}
                        </span>
                      </div>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <div className="text-center p-3">
                <div className="text-center" role="status">
                  <h5>There are no product to ship...</h5>
                </div>
              </div>
            )}
            {packages &&
              packages.map(
                (pkg, index) =>
                  pkg.shipment_id == shipment.shipment_id && (
                    <div key={index}>
                      {isShippingOrder && (
                        <div className="d-flex justify-content-between pb-3 bottom-border-line">
                          <h5 className="fw-bold">
                            {" "}
                            Pakket: {pkg.package_number}
                          </h5>
                        </div>
                      )}
                      <div
                        className={`shipment-status-info-container d-flex column align-center justify-content-between pb-4 ${
                          isShippingOrder ? "pt-4" : ""
                        }`}
                      >
                        <div className="row border-right-gray col-6 packaging-info w-50">
                          <div className="col-6">
                            {shipmentMethod === 1 && <p>Track en trace:</p>}
                            <p>Datum aangemaakt:</p>
                            <p>Gekozen provider: </p>
                          </div>
                          <div className="col-6 pe-0 d-flex flex-column align-items-end">
                            {shipmentMethod === 1 &&
                              (pkg.package_code ? (
                                <p className="new-link-color text-decoration-underline">
                                  {pkg.package_code}
                                </p>
                              ) : (
                                "N/A"
                              ))}
                            <p>
                              {new Date(pkg.created_at)
                                .toLocaleString("nl-NL", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })
                                .replace(",", " om")}
                            </p>
                            <p>
                              {getProviderAndMethod(shipment, pkg, providers)}
                            </p>
                          </div>
                        </div>
                        <PackageStatus
                          pickup={!isShippingOrder}
                          status={pkg.status}
                        />
                      </div>
                    </div>
                  )
              )}
          </div>
        );
      })}
    </>
  );

};

export default React.memo(VerzendComponent);